// extracted by mini-css-extract-plugin
module.exports = {"root":"Upload_root__tM4Ol","label":"Upload_label__Q2dpx","labelName":"Upload_labelName__zClse","errorText":"Upload_errorText__wr_eG"};